var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row mb-5"},[_c('span',{staticClass:"display-4 col-12"},[_vm._v(" "+_vm._s(`${_vm.product.name}`)+" - "+_vm._s(_vm.$t("COMMON.PURCHASES_ORDERS"))+" ")])]),_c('purchases-order-list-table',{attrs:{"filterProduct":_vm.product.id,"filterOrganization":_vm.product.organization.id,"product":_vm.product}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }